import { render, staticRenderFns, recyclableRender, components } from "./u-datetime-picker.vue?vue&type=template&id=fbda4e8a&scoped=true&"
var renderjs
import script from "./u-datetime-picker.vue?vue&type=script&lang=js&"
export * from "./u-datetime-picker.vue?vue&type=script&lang=js&"
import style0 from "./u-datetime-picker.vue?vue&type=style&index=0&id=fbda4e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbda4e8a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-datetime-picker/u-datetime-picker.vue"
export default component.exports